function parseScrollPadding(value: string): number {
  if (value === "auto") return 0;
  return parseFloat(value);
}

for (const el of document.querySelectorAll<HTMLElement>(".scrollometer")) {
  const bar = el.querySelector<HTMLElement>(".scrollometer__bar");
  if (bar == null) {
    console.warn("Scrollometer with no bar", el);
    continue;
  }

  const selector = el.dataset.selector;
  if (selector == null) {
    console.warn("Scrollometer with no selector", el);
    continue;
  }

  const target = document.querySelector<HTMLElement>(selector);
  if (target == null) {
    console.warn(
      `Scrollometer selector "${selector}" points to no element`,
      el
    );
    continue;
  }

  function update(): void {
    // Get relevant data
    const viewportHeight = window.innerHeight;
    const documentStyle = getComputedStyle(document.documentElement);
    const scrollPaddingBottom = parseScrollPadding(
      documentStyle.scrollPaddingBottom
    );
    const targetRect = target!.getBoundingClientRect();
    const scrollTop = document.documentElement.scrollTop;

    // If the top of the target element is somewhere within the first viewport,
    // treat scrollTop=0 as the beginning.
    // Otherwise, the beginning is where the target first comes into view.
    const scrollTopStart =
      targetRect.top + scrollTop + scrollPaddingBottom < viewportHeight
        ? 0
        : targetRect.top + scrollTop + scrollPaddingBottom - viewportHeight;

    // The end is when the bottom of the target is first in view.
    const scrollTopEnd =
      targetRect.bottom + scrollTop + scrollPaddingBottom - viewportHeight;

    const progress = Math.max(
      0,
      Math.min(
        1,
        (scrollTop - scrollTopStart) / (scrollTopEnd - scrollTopStart)
      )
    );

    bar!.style.width = `${100 * progress}%`;
    bar!.style.opacity = progress < 1 ? "1" : "0";
  }

  update();
  window.addEventListener("resize", update);
  window.addEventListener("scroll", update);
}
